import { _ as __rest } from './_tslib.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useState } from 'react';
import { generateClasses } from '@ids/tools';
import { I as IdsIcon } from './icon.js';
import { s as styleInject } from './style-inject.es.js';
import { u as useId } from './use-id.js';

var css_248z = "/*\n** Voxel Foundation Formats\n*/\n.ids-animation-fade-in-start {\n  opacity: 0;\n}\n\n.ids-animation-fade-in-moderate-end {\n  opacity: 1;\n  -webkit-transition: opacity 200ms cubic-bezier(0.42, 0, 0.58, 1);\n  transition: opacity 200ms cubic-bezier(0.42, 0, 0.58, 1);\n}\n\n.ids-animation-fade-out-start {\n  opacity: 1;\n}\n\n.ids-animation-fade-out-moderate-output-end {\n  opacity: 0;\n  -webkit-transition: opacity 275ms cubic-bezier(0.42, 0, 0.58, 1);\n  transition: opacity 275ms cubic-bezier(0.42, 0, 0.58, 1);\n}\n\n.ids-animation-scale-x-down {\n  -webkit-transform: scaleX(var(--ids-scale-x-down, 0));\n          transform: scaleX(var(--ids-scale-x-down, 0));\n}\n\n.ids-animation-scale-x-up {\n  -webkit-transform: scaleX(var(--ids-scale-x-up, 100%));\n          transform: scaleX(var(--ids-scale-x-up, 100%));\n}\n\n.ids-animation-time-transform-slow {\n  -webkit-transition: -webkit-transform 2000ms cubic-bezier(0, 0, 0.58, 1);\n  transition: -webkit-transform 2000ms cubic-bezier(0, 0, 0.58, 1);\n  transition: transform 2000ms cubic-bezier(0, 0, 0.58, 1);\n  transition: transform 2000ms cubic-bezier(0, 0, 0.58, 1), -webkit-transform 2000ms cubic-bezier(0, 0, 0.58, 1);\n}\n\n.ids-animation-width-down {\n  width: var(--ids-width-down, 0);\n}\n\n.ids-animation-width-up {\n  width: var(--ids-width-up, 100%);\n}\n\n.ids-animation-time-width-slow {\n  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */\n  -webkit-transition: width 2000ms cubic-bezier(0, 0, 0.58, 1);\n  transition: width 2000ms cubic-bezier(0, 0, 0.58, 1);\n}\n\n.ids-accordion {\n  background-color: var(--ids_color_bg_base);\n}\n.ids-accordion__trigger {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: var(--ids_color_bg_base);\n  border: 0;\n  border-bottom: var(--ids_size_border_small) solid var(--ids_color_border_soft);\n  color: var(--ids_color_text_body_01);\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 0;\n  gap: var(--ids_spacing_3x);\n  line-height: 1;\n  outline-offset: var(--ids_size_general_1x);\n  overflow: hidden;\n  padding: var(--ids_spacing_4x) var(--ids_spacing_4x) var(--ids_spacing_3x) 0;\n  width: 100%;\n}\n.ids-accordion__trigger:focus, .ids-accordion__trigger:hover {\n  background-color: var(--ids_color_action_neutral_base_soft);\n}\n.ids-accordion__header {\n  color: var(--ids_color_action_neutral_variant);\n  display: grid;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  font: var(--ids_textStyle_f02_s16_h24_wrg);\n  text-align: left;\n}\n.ids-accordion__header > *:not(.ids-accordion__description) {\n  font: inherit;\n  font-weight: inherit;\n}\n.ids-accordion__description {\n  color: var(--ids_color_action_neutral_base);\n  font: var(--ids_textStyle_f02_s14_h20_wrg);\n}\n.ids-accordion__toggle {\n  -ms-flex-item-align: center;\n      align-self: center;\n  margin-left: var(--ids_spacing_1x);\n  -webkit-transition: -webkit-transform 0.5s;\n  transition: -webkit-transform 0.5s;\n  transition: transform 0.5s;\n  transition: transform 0.5s, -webkit-transform 0.5s;\n}\n.ids-accordion__content {\n  opacity: 0;\n  padding: var(--ids_size_general_24x) 0;\n  -webkit-transform: translateY(-0.75rem);\n          transform: translateY(-0.75rem);\n  -webkit-transition: opacity 375ms linear, -webkit-transform 300ms 50ms cubic-bezier(0, 0, 0.58, 1);\n  transition: opacity 375ms linear, -webkit-transform 300ms 50ms cubic-bezier(0, 0, 0.58, 1);\n  transition: opacity 375ms linear, transform 300ms 50ms cubic-bezier(0, 0, 0.58, 1);\n  transition: opacity 375ms linear, transform 300ms 50ms cubic-bezier(0, 0, 0.58, 1), -webkit-transform 300ms 50ms cubic-bezier(0, 0, 0.58, 1);\n}\n.ids-accordion__body {\n  font: var(--ids_textStyle_f02_s16_h24_wrg);\n  max-height: 0;\n  overflow-y: auto;\n  -webkit-transition-delay: 375ms;\n          transition-delay: 375ms;\n  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */\n  -webkit-transition-property: max-height;\n  transition-property: max-height;\n}\n.ids-accordion--expanded .ids-accordion__toggle {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.ids-accordion--expanded .ids-accordion__content {\n  opacity: 1;\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n  -webkit-transition: opacity 350ms linear, -webkit-transform 300ms cubic-bezier(0.42, 0, 1, 1);\n  transition: opacity 350ms linear, -webkit-transform 300ms cubic-bezier(0.42, 0, 1, 1);\n  transition: opacity 350ms linear, transform 300ms cubic-bezier(0.42, 0, 1, 1);\n  transition: opacity 350ms linear, transform 300ms cubic-bezier(0.42, 0, 1, 1), -webkit-transform 300ms cubic-bezier(0.42, 0, 1, 1);\n}\n.ids-accordion--expanded .ids-accordion__body {\n  max-height: var(--ids-accordion-max-height);\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}";
styleInject(css_248z);

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsAccordion } from '@ids/react';
 * ```
 */
const IdsAccordion = _a => {
  var {
      id: externalId,
      open: externalOpen,
      className = '',
      icon,
      header,
      description,
      expandedMaxHeight,
      iconProps,
      arrowProps,
      setOpen: externalSetOpen,
      children
    } = _a,
    props = __rest(_a, ["id", "open", "className", "icon", "header", "description", "expandedMaxHeight", "iconProps", "arrowProps", "setOpen", "children"]);
  const id = useId(externalId, 'ids-react-accordion');
  const [internalOpen, setInternalOpen] = useState(Boolean(externalOpen));
  const setOpen = externalSetOpen !== null && externalSetOpen !== void 0 ? externalSetOpen : setInternalOpen;
  const open = externalSetOpen ? externalOpen : internalOpen;
  const classes = generateClasses({
    'ids-accordion': true,
    'ids-accordion--expanded': open,
    [className]: className
  });
  const triggerClasses = generateClasses({
    'ids-accordion__trigger': true,
    'ids-accordion__trigger--double-line': Boolean(description)
  });
  function handleToggle() {
    setOpen(!open);
  }
  function renderIcon() {
    if (typeof icon == 'string') {
      return (
        // TODO: mudar para neutral
        jsx(IdsIcon, Object.assign({
          size: "M"
        }, iconProps, {
          children: icon
        }))
      );
    }
    return icon;
  }
  return jsxs("div", Object.assign({
    className: classes
  }, props, {
    style: {
      '--ids-accordion-max-height': expandedMaxHeight || '9999px'
    }
  }, {
    children: [jsxs("button", Object.assign({
      className: triggerClasses,
      id: id,
      "aria-controls": `content-${id}`,
      "aria-expanded": open,
      onClick: handleToggle
    }, {
      children: [icon && jsx("div", Object.assign({
        className: "ids-accordion__icon"
      }, {
        children: renderIcon()
      })), jsxs("div", Object.assign({
        className: "ids-accordion__header"
      }, {
        children: [header, description && jsxs(Fragment, {
          children: [jsx("span", Object.assign({
            className: "ids-sr-only"
          }, {
            children: "\u00A0"
          })), jsx("span", Object.assign({
            className: "ids-accordion__description"
          }, {
            children: description
          }))]
        })]
      })), jsx("div", Object.assign({
        className: "ids-accordion__toggle"
      }, {
        children: jsx(IdsIcon, Object.assign({
          size: "M"
        }, arrowProps, {
          children: "seta_baixo"
        }))
      }))]
    })), jsx("div", Object.assign({
      id: `content-${id}`,
      className: "ids-accordion__body",
      "aria-hidden": !open
    }, {
      children: jsx("div", Object.assign({
        className: "ids-accordion__content"
      }, {
        children: children
      }))
    }))]
  }));
};

export { IdsAccordion as I };
//# sourceMappingURL=accordion.js.map
